import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function createExamItemRage(payload) {
	let createdItemRange = null;

	try{
		const content = {
			method: API_POST_METHOD,
			url: `settings/examresultrange`,
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			createdItemRange = data.RECORDS;
		} 
	}
	catch(e) {
		showMessage(e);
	}

	return createdItemRange;
}

export async function updateExamItemRage(payload) {
	let isSuccess = null;

	try{
		const content = {
			method: API_PUT_METHOD,
			url: `settings/examresultrange`,
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;
		// Handle new API response format
		isSuccess = data.STATUSCODE === 200  
	}
	catch(e) {
		showMessage(e);
	}

	return isSuccess;
}


export async function getAnalyzers() {
	let analyzers = [];

	try{
		const content = {
			method: API_GET_METHOD,
			url: `settings/examresultrange?p_analyzer_flag=1`,
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			analyzers = data.RECORDS;
		} else {
			analyzers = data || [];
		}
	}
	catch(e) {
		showMessage(e);
	}

	return analyzers;
}


export async function getAllItemRanges(ExamItemID) {
	let examItemRanges = [];

	try{
		const content = {
			method: API_GET_METHOD,
			url: `settings/examresultrange?p_exam_item_id=${ExamItemID}`, 
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			examItemRanges = data.RECORDS;
		} 

	}
	catch(e) {
		showMessage(e);
	}

	return examItemRanges;
}

// Silent version for background processes like export
export async function getAllItemRangesSilent(ExamItemID) {
	let examItemRanges = [];

	try{
		const content = {
			method: API_GET_METHOD,
			url: `settings/examresultrange?p_exam_item_id=${ExamItemID}`, 
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			examItemRanges = data.RECORDS;
		} 
	}
	catch(e) {
		console.error("Silent fetch error:", e);
	}

	return examItemRanges;
}
